module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    ref: "newGame",
    staticClass: "mdl-dialog",
    on: {
      "close": _vm.close
    }
  }, [_c('h6', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("New Game")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('div', {
    ref: "size",
    staticClass: "mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.size),
      expression: "size"
    }],
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": "game-size"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.size = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sizes), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "game-size"
    }
  }, [_vm._v("Game Size")])]), _vm._v(" "), (_vm.online) ? _c('mdl-switch', {
    attrs: {
      "id": "play-online"
    },
    model: {
      value: (_vm.remoteGame),
      callback: function($$v) {
        _vm.remoteGame = $$v
      },
      expression: "remoteGame"
    }
  }, [_vm._v("Play Online")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('mdl-button', {
    directives: [{
      name: "mdl-ripple-effect",
      rawName: "v-mdl-ripple-effect"
    }],
    attrs: {
      "disabled": !_vm.size
    },
    nativeOn: {
      "click": function($event) {
        _vm.doNewGame($event)
      }
    }
  }, [_vm._v("New Game")]), _vm._v(" "), _c('mdl-button', {
    directives: [{
      name: "mdl-ripple-effect",
      rawName: "v-mdl-ripple-effect"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3105c712"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/NewGameDialog.vue
// module id = 417
// module chunks = 1